module.exports = __webpack_public_path__ + "static/media/SiteNavIconActive.571aa9ab.svg";